import { fetchingProduct } from "../helpers/fetchingProduct";

if (document.querySelector("#shoppingCart")) {
  const openCart = document.querySelector("#shoppingCart"),
    body = document.querySelector("body"),
    closeCart = document.querySelector(".mini-cart__close"),
    miniCart = document.querySelector(".mini-cart"),
    overlayCart = document.querySelector(".mini-cart__overlay");

  openCart.addEventListener("click", (event) => {
    event.stopPropagation();
    openMiniCart();
  });

  if (closeCart) {
    closeCart.addEventListener("click", (event) => {
      event.stopPropagation();
      closeMiniCart();
    });
  }

  if (overlayCart) {
    overlayCart.addEventListener("click", (event) => {
      event.stopPropagation();
      closeMiniCart();
    });
  }

  function handleClickOutsideMiniCart(event) {
    if (!miniCart.contains(event.target) && !openCart.contains(event.target)) {
      closeMiniCart();
    }
  }

  function closeMiniCart() {
    miniCart.classList.remove("visible");
    document.removeEventListener("click", handleClickOutsideMiniCart);
    body.classList.remove("hidden");
  }
}

export function openMiniCart() {
  const body = document.querySelector("body"),
    miniCart = document.querySelector(".mini-cart");
  miniCart.classList.add("visible");
  body.classList.add("hidden");
  fetchingProduct("/cart.js", "GET");
}
